import './App.css';
import React from "react"
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from "react-router-dom"

import DadosUSPApp from "./components/DadosUSPApp"
import Login from "./components/Login"
import StoragePage from "./components/StoragePage"
import UserProfilePage from "./components/UserProfilePage"
import ManageUsersPage from "./components/ManageUsersPage"
import PrivateRoute from "./components/PrivateRoute"
import { AuthProvider } from "./context/AuthContext"
import Previsoes from './components/Previsoes';

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <DadosUSPApp />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/repositorio"
                        element={
                            <PrivateRoute>
                                <StoragePage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/meu-perfil"
                        element={
                            <PrivateRoute>
                                <UserProfilePage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/gerenciar-usuarios"
                        element={
                            <PrivateRoute>
                                <ManageUsersPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/previsoes"
                        element={
                            <PrivateRoute>
                                <Previsoes />
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    )
}

export default App;
